import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Exercice } from '../model/exercice.model';
import { ExerciceList } from '../model/exerciceList.model';
import { Student } from '../model/student.model';
import { ExerciceSheetContent } from '../model/exerciceSheetContent.model';

@Injectable()
export class ExerciceService extends KiwixiService {

    apiExercice = environment.server + 'exercices/';
    apiCurrent = this.apiExercice + 'current/';

    difficultyList = [
        { 'data': 'easy', 'label': 'Facile' },
        { 'data': 'medium', 'label': 'Moyen' },
        { 'data': 'hard', 'label': 'Difficle' },
    ];

    getExerciceStatus() {
        return [
            {
                label: 'Incomplet',
                code: 'uncomplete',
                valid: true
            },
            {
                label: 'Deleted',
                code: 'deleted',
                valid: true
            },
            {
                label: 'Publié',
                code: 'published',
                valid: true
            },
            {
                label: 'Désactivée',
                code: 'disabled',
                valid: true
            }
        ];
    }

    validatePercentStep = 80;
    practicePercentStep = 100;

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,) {
        super(_http, _router, kiwixiGlobals, materialService);
    }
    getDifficultyList() {
        return this.difficultyList;
    }
    getExerciceById(_id): Observable<Exercice> {
        const url = this.apiExercice + _id + '/';
        return this.getExerciceByUrl(url);
    }

    getExerciceByUrl(_url): Observable<Exercice> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<Exercice>(_url, {
            headers: header
        })
            .pipe(
                catchError(this.handleErrorObservable<any>(`getExercice`))
            );
    }

    getExerciceByIdWithStudent(_id, student: Student): Observable<Exercice> {
        const url = this.apiExercice + _id + '/';
        const header = this.createHttpClientAuthorizationHeader();
        const params = new HttpParams()
            .set('is_validate_by_student', student.id.toString())
            .set('is_todo_by_student', student.id.toString())
            .set('salt', Math.random().toString());
        return this._http.get<Exercice>(url, {
            headers: header,
            params: params
        })
            .pipe(
                catchError(this.handleErrorObservable<any>(`getExercice`))
            );
    }

    getExercices(params: HttpParams): Observable<ExerciceList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExerciceList>(this.apiExercice, {
            headers: header,
            params: params
        })
            .pipe(
                map(_Exercices => _Exercices),
                catchError(this.handleErrorObservable<ExerciceList>(`getObservableExercices`))
            );
    }

    getExercicesByUrl(_url): Observable<ExerciceList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExerciceList>(_url, {
            headers: header
        })
            .pipe(
                catchError(this.handleErrorObservable<ExerciceList>(`getExercice`))
            );
    }

    patchFile(ExerciceUrl, param, field, file): Promise<Exercice> {
        const self = this;
        const headers = this.createHttpClientAuthorizationHeaderNoEnctype();
        const _formData = new FormData();
        _formData.append('enctype', 'multipart/form-data');
        self.headers.delete('Content-Type');
        _formData.append(field, file);
        _formData.append('name', file.name);
        return this._http.patch(ExerciceUrl, _formData, { headers: headers })
            .toPromise()
            .then((res: any) => res)
    }

    postExercice(params) {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.post<Exercice>(this.apiExercice, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<Exercice>(`Création d'une fiche`)),
            );
    }

    patchExercice(_id, params) {
        const url = this.apiExercice + _id + '/';
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.patch<Exercice>(url, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<Exercice>(`Création d'une fiche`)),
            );
    }

    deleteExercice(id): Observable<Exercice> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.delete<Exercice>(this.apiExercice + id + '/', {
            headers: header,
        })
            .pipe(
                catchError(this.handleErrorObservable<Exercice>(`delete Exercice`))
            );
    }
    getRandomNotValidatedExercice(params): Observable<Exercice> {
        const url = this.apiExercice + 'random_not_validated/' + '?salt=' + Math.random();
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<Exercice>(url, {
            headers: header,
            params: params
        })
            .pipe(
                catchError(this.handleErrorObservable<Exercice>(`getRandomNotValidatedExercice`))
            );
    }

    getContentValueByTypeContent(typeContent: string, contentArray: ExerciceSheetContent[]): string {
        const content = contentArray.find(item => item.type_content.slug === typeContent);
        return content ? content.value : '';
    }
}
